import styled from 'styled-components';

import { basicBodyTextStyle, Text } from '@dreryk/react-components';

export const StyledVisitHistoryText = styled(Text)`
   ${basicBodyTextStyle};
   white-space: pre-wrap;
   word-break: break-word;
`;
StyledVisitHistoryText.displayName = 'StyledVisitHistoryText';
